export default __webpack_public_path__ + "static/media/click_next.258a06a9.mp3";